var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_vm._m(0),_c('div',{staticClass:"info"},[_c('p',[_vm._v(_vm._s(_vm.$t('invitation.error.text')))])]),_c('div',{staticClass:"actions"},[_c('router-link',{attrs:{"to":"/login"}},[_c('button',[_vm._v(_vm._s(_vm.$t('invitation.error.button')))])])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"jilsterImg"},[_c('img',{attrs:{"src":"/error.png"}})])
}]

export { render, staticRenderFns }